
//获取来源
export function getOrigin() {
    var origin = ''; //用于区分来源
    //优先判断微信打开和QQ打开，然后才是南方号、pc，最后是浏览器
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") { //微信打开
        origin = 'weChatShare';
        return origin;
    } else if (ua.match(/QQ/i) == 'qq') { //qq打开
        origin = 'qqShare';
        return origin;
    } else if (document.referrer.indexOf('southcn.com/content/pc/') > -1) { //pc
        origin = 'pc';
    } else {
        origin = 'browserShare';
        return origin;
    }
  }
  


// WEBPACK FOOTER //
// ./src/js/getOrigin.js